import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { apiConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const resendVoucher = (tokens: any, voucherId: any, remitterId: string) => {
  const config = apiConfig(tokens)
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers.userIDToken = RootStore?.bcAppInfo?.userIdentifier
  const request: Request<{}> = {
    //apiPath:'http://10.162.6.163:9023/resendVoucher',
    apiPath: APIEndPoints.resendVoucher,
    method: 'POST',
    config,
    body: resendVoucherRequest(voucherId, remitterId),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}

const resendVoucherRequest = (voucherId: string, remitterId: string) => {
  return {
    voucherId,
    remitterId,
  }
}
